import css from './wallet.module.scss';
import {Tab} from '../../components/tab/tab';
import {tabs} from './wallet.helper';
import {WalletHeader} from './wallet-header/wallet-header';
import {NFTItem} from '../../components/nft-item/nft-item';
import {Transaction} from '../../components/transaction/transaction';
import {TRANSACTIONS, NFT_LIST} from './wallet.mock';
import {useState} from 'react';
import {useNavigate} from '@tanstack/react-location';

export const Wallet = (): JSX.Element => {
	const onTransactionClick = () => {
		navigate({to: '/transaction-detail'});
	};

	const onNFTClick = () => {
		navigate({to: '/nft-detail'});
	};

	const transactionList = TRANSACTIONS.map((tx) => {
		// TODO: change key to a unique value after setting up api calls
		return <Transaction key={tx.time} {...tx} onClick={onTransactionClick} />;
	});

	const nftList = NFT_LIST.map((nft) => {
		// TODO: change key to a unique value after setting up api calls
		return <NFTItem key={nft.name} {...nft} onClick={onNFTClick} />;
	});

	const [list, setList] = useState(nftList);
	const navigate = useNavigate();

	// TODO: fix tabName types
	const onTabChange = (tabName: unknown) => {
		if (tabName === tabs.transactions) {
			setList(transactionList);
			return;
		}
		setList(nftList);
	};

	return (
		<div className={css.container}>
			<WalletHeader balance="9,500" />
			<div className={css.body}>
				<div className={css.tabContainer}>
					<Tab tabNames={[tabs.transactions, tabs.NFT]} onChange={onTabChange} selected={tabs.NFT} />
				</div>
				<div className={css.listContainer}>{list}</div>
			</div>
		</div>
	);
};
